const _version = "3.4.0"
function version() {
    return _version
}
export default version
